module.exports = "#version 300 es\nprecision highp float;\n\nin vec4 fs_Col;\nin vec4 fs_Pos;\nin vec4 fs_Nor;\n\nout vec4 out_Col;\n\nvoid main()\n{\n    float dist = 1. - (length(fs_Pos.xyz) * 2.0);\n    out_Col = vec4(dist);\n}"


//////////////////
// WEBPACK FOOTER
// ./src/shaders/snow-frag.glsl
// module id = 84
// module chunks = 0